import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTiktok, FaInstagram } from "react-icons/fa6";

const API_URL = "https://pro-erp-system.stacknet.lk/items/api/public";

const toSlug = (name) =>
  name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

const staticLinks = [
  { label: "Home", path: "/" },
  { label: "Shop", path: "/shop" },
];

export default function Footer() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setCategories(data.categories);
      })
      .catch(() => {});
  }, []);

  const allLinks = [
    ...staticLinks,
    ...categories.map((cat) => ({
      label: cat.name,
      path: `/${toSlug(cat.name)}`,
    })),
  ];

  return (
    <footer style={{
      background: "#0a0a0a",
      borderTop: "1px solid #1f1f1f",
      fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
      color: "#fff",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap');
        .footer-nav-link {
          color: #9ca3af;
          text-decoration: none;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          font-family: 'Barlow', sans-serif;
          transition: color 0.2s;
        }
        .footer-nav-link:hover { color: #ef4444; }
        .social-icon {
          width: 38px; height: 38px;
          display: flex; align-items: center; justify-content: center;
          border: 1px solid #1f1f1f;
          border-radius: 3px;
          color: #9ca3af;
          font-size: 1rem;
          text-decoration: none;
          transition: border-color 0.2s, color 0.2s, background 0.2s;
        }
        .social-icon:hover { border-color: #ef4444; color: #fff; background: #ef4444; }
        .stacknet-logo { transition: opacity 0.2s, transform 0.2s; }
        .stacknet-logo:hover { opacity: 0.75; transform: scale(1.05); }
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-contact-col { grid-column: 1 / -1; }
        }
        @media (max-width: 560px) {
          .footer-grid { grid-template-columns: 1fr !important; }
          .footer-bottom { flex-direction: column !important; align-items: flex-start !important; gap: 1rem !important; }
        }
      `}</style>

      {/* MAIN BODY */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "3.5rem 2.5rem 2.5rem" }}>
        <div className="footer-grid" style={{
          display: "grid",
          gridTemplateColumns: "220px 1fr 200px",
          gap: "3rem",
          alignItems: "start",
        }}>

          {/* BRAND */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "1.25rem" }}>
              <img
                src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741282821/Pro_Nutrition-01-removebg-preview_thyf18.png"
                alt="Pro Nutrition Logo"
                style={{ height: "44px", width: "44px", objectFit: "contain" }}
              />
              <span style={{ fontSize: "1.2rem", fontWeight: 900, letterSpacing: "0.1em", color: "#fff" }}>
                PRO <span style={{ color: "#ef4444" }}>NUTRITION</span>
              </span>
            </div>
            <p style={{
              color: "#4b5563", fontFamily: "'Barlow', sans-serif",
              fontSize: "0.85rem", lineHeight: 1.7, marginBottom: "1.5rem",
            }}>
              Sri Lanka's #1 supplement store. Authentic products, island-wide delivery, expert advice.
            </p>
            <div style={{ display: "flex", gap: "8px" }}>
              <a href="https://www.facebook.com/share/18rE8fPTy5/?mibextid=wwXIfr"
                target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.tiktok.com/@pro_nutrition__?_t=ZS-8uVSAKJfdAN&_r=1"
                target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a href="https://www.instagram.com/pro_nutrition_store?igsh=MXR2Z2xtNnJ0aWdldg=="
                target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* DYNAMIC NAV LINKS */}
          <div>
            <p style={{
              color: "#4b5563", fontSize: "0.7rem", fontWeight: 700,
              letterSpacing: "0.2em", textTransform: "uppercase",
              fontFamily: "'Barlow', sans-serif", marginBottom: "1.25rem",
            }}>Quick Links</p>
            {allLinks.length > 0 ? (
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
                gap: "0.6rem 1.5rem",
              }}>
                {allLinks.map((item) => (
                  <Link key={item.path} to={item.path} className="footer-nav-link">
                    {item.label}
                  </Link>
                ))}
              </div>
            ) : (
              /* Skeleton while loading */
              <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
                {[...Array(6)].map((_, i) => (
                  <div key={i} style={{
                    height: "12px", width: `${60 + (i % 3) * 20}px`,
                    background: "#1a1a1a", borderRadius: "2px",
                  }} />
                ))}
              </div>
            )}
          </div>

          {/* CONTACT */}
          <div className="footer-contact-col">
            <p style={{
              color: "#4b5563", fontSize: "0.7rem", fontWeight: 700,
              letterSpacing: "0.2em", textTransform: "uppercase",
              fontFamily: "'Barlow', sans-serif", marginBottom: "1.25rem",
            }}>Contact</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              <div>
                <p style={{ color: "#6b7280", fontFamily: "'Barlow', sans-serif", fontSize: "0.75rem", marginBottom: "2px" }}>
                  Phone / WhatsApp
                </p>
                <a
                  href="https://api.whatsapp.com/send?phone=+94765794062&text=Hello%2C%20I%20want%20to%20order%20supplements!"
                  target="_blank" rel="noreferrer"
                  style={{ color: "#ef4444", fontFamily: "'Barlow', sans-serif", fontSize: "0.95rem", fontWeight: 600, textDecoration: "none" }}
                >
                  +94 76 579 4062
                </a>
              </div>
              <div>
                <p style={{ color: "#6b7280", fontFamily: "'Barlow', sans-serif", fontSize: "0.75rem", marginBottom: "2px" }}>
                  Address
                </p>
                <p style={{ color: "#d1d5db", fontFamily: "'Barlow', sans-serif", fontSize: "0.85rem", lineHeight: 1.6 }}>
                  417, 1 Galle Rd,<br />Moratuwa 10400,<br />Sri Lanka
                </p>
              </div>
              <a
                href="https://api.whatsapp.com/send?phone=+94765794062&text=Hello%2C%20I%20want%20to%20order%20supplements!"
                target="_blank" rel="noreferrer"
                style={{
                  display: "inline-block", background: "#ef4444",
                  color: "#fff", textDecoration: "none",
                  padding: "10px 20px", borderRadius: "3px",
                  fontWeight: 800, fontSize: "0.78rem",
                  letterSpacing: "0.1em", textTransform: "uppercase",
                  marginTop: "0.25rem", alignSelf: "flex-start",
                }}
              >
                Order Now →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div style={{ borderTop: "1px solid #1a1a1a" }}>
        <div className="footer-bottom" style={{
          maxWidth: "1200px", margin: "0 auto",
          padding: "1.25rem 2.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "1rem",
        }}>
          <p style={{
            color: "#374151", fontFamily: "'Barlow', sans-serif", fontSize: "0.78rem",
          }}>
            © {new Date().getFullYear()} Pro Nutrition Sri Lanka. All rights reserved.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{
              color: "#374151", fontFamily: "'Barlow', sans-serif",
              fontSize: "0.75rem", letterSpacing: "0.05em",
            }}>
              Designed &amp; Developed by
            </span>
            <a href="https://stacknet.lk/" target="_blank" rel="noopener noreferrer" className="stacknet-logo">
              <img
                src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741405701/2Asset_2gf9_white_lojr1i.png"
                alt="StackNet"
                style={{ height: "22px", objectFit: "contain", display: "block" }}
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}